import moment from 'moment';

export const MORE_TICKERS = {
  'Oil Futures': [
    { name: 'Crude Oil', symbol: 'Crude%20Oil%20-%20Electronic' },
    { name: 'Brent Crude', symbol: 'BRENT%20CRUDE' }
  ],
  Currencies: [
    { name: 'USD/EUR', symbol: 'USDEUR' },
    { name: 'USDJPY', symbol: 'USDJPY' },
    { name: 'WSJ DollarIdx', symbol: 'XX:BUXX' }
  ],
  Bonds: [
    { name: '10 Year Yield', symbol: 'BX:TMUBMUSD10Y' }
  ],
  'Foreign Indexes': [
    { name: 'Stoxx Europe 600', symbol: 'XX:SXXP' },
    { name: 'Nikkei IDX', symbol: 'JP:NIK' },
    { name: 'HANG SENG INDEX', symbol: 'HK:HSI' },
    { name: 'Shanghai Comp', symbol: 'CN:SHCOMP' },
    { name: 'Shenzhen', symbol: 'CN:399106' }
  ]
};

export const RANGE = {
  '1D': { value: 'D1', start: 'PT1M', end: 'PT1H', default: 'PT5M' },
  '2D': { value: 'D2', start: 'PT1M', end: 'PT1H', default: 'PT5M' },
  '3D': { value: 'D3', start: 'PT1M', end: 'PT1H', default: 'PT5M' },
  '4D': { value: 'D4', start: 'PT1M', end: 'PT1H', default: 'PT10M' },
  '5D': { value: 'D5', start: 'PT1M', end: 'P1D', default: 'PT10M' },
  '10D': { value: 'D10', start: 'PT1M', end: 'P1D', default: 'PT15M' },
  '1M': { value: 'P29D', start: 'P1D', end: 'P7D', default: 'P1D' },
  '3M': { value: 'P3M', start: 'P1D', end: 'P1M', default: 'P1D' },
  '6M': { value: 'P6M', start: 'P1D', end: 'P3M', default: 'P1D' },
  'YTD': { value: 'YTD', start: 'P1D', end: 'P1M', default: 'P1D' },
  '1Y': { value: 'P1Y', start: 'P1D', end: 'P3M', default: 'P1D' },
  '2Y': { value: 'P2Y', start: 'P1D', end: 'P1Y', default: 'P7D' },
  '3Y': { value: 'P3Y', start: 'P1D', end: 'P1Y', default: 'P7D' },
  '5Y': { value: 'P5Y', start: 'P1D', end: 'P1Y', default: 'P1M' },
  '10Y': { value: 'P10Y', start: 'P1D', end: 'P1Y', default: 'P3M' },
  'All': { value: 'all', start: 'P1D', end: 'P1Y', default: 'P3M' },
  'Custom': { value: 'custom' }
};

export function getRangeOptions(/*hasFutures*/) {
  // const startIdx = hasFutures ? 6 : 0;
  return Object.keys(RANGE);//.slice(startIdx);
}

const FREQUENCY = [
  { value: 'PT1M', text: '1 min' },
  { value: 'PT5M', text: '5 min' },
  { value: 'PT10M', text: '10 min' },
  { value: 'PT15M', text: '15 min' },
  { value: 'PT1H', text: 'Hourly' },
  { value: 'P1D', text: 'Daily' },
  { value: 'P7D', text: 'Weekly' },
  { value: 'P1M', text: 'Monthly' },
  { value: 'P3M', text: 'Quarterly' },
  { value: 'P1Y', text: 'Yearly' }
];

export function getFrequencyOptions(dateRange, startDate, endDate, hasCrypto) {
  // populate frequency dropdown with proper options for specified date range
  const isCustom = dateRange === 'Custom';
  if (isCustom) {
    // for custom dates, determine which preset date range is closest in length
    const [unixStart, unixEnd] = [startDate, endDate].map(convertDate);
    const timeSpan = unixEnd - unixStart;
    dateRange = getRange(timeSpan);
  }
  const noIntraday = checkIntraday(endDate, isCustom); // for older custom dates, intraday intervals unavailable
  
  const { start, end, defaultFrequency } = getFrequencyDefaults(dateRange, hasCrypto, noIntraday);
  
  const frequencyOptions = hasCrypto && !isIntraday(defaultFrequency) ?
    [FREQUENCY[5], ...FREQUENCY.slice(7)]
    :
    getOptions(start, end);
  
  return { frequencyOptions, defaultFrequency };
}

export function parseDateRange(dateRange) {
  return {
    timePeriodType: dateRange.slice(-1),
    timeValue: +dateRange.slice(0, -1)
  };
}

// getFrequencyOptions helper functions
function convertDate(date) {
  return date.format('x');
}

function getRange(timeSpan) {
  const timePeriods = getTimePeriods();
  let current;
  for (let i = 0; i < timePeriods.length; i++) {
    current = timePeriods[i];
    if (timeSpan < current.milliseconds) {
      const prev = timePeriods[i - 1];
      return i === 0 || checkDate(timeSpan, prev, current) ?
        current.range : prev.range;
    }
  }
  return current.range;
}

function getTimePeriods() {
  return Object.keys(RANGE)
    .map(createTimeSpanObj)
    .filter(rangeObj => !isNaN(rangeObj.milliseconds));
}

const D = 1000 * 60 * 60 * 24;
const M = D * 30;
const Y = D * 365;

const TIMETYPES = { D, M, Y };

function createTimeSpanObj(range) {
  const { timePeriodType, timeValue } = parseDateRange(range);
  const milliseconds = TIMETYPES[timePeriodType] * timeValue;
  return { range, milliseconds };
}

function checkDate(timeSpan, prev, current) {
  return timeSpan - prev.milliseconds > current.milliseconds - timeSpan;
}

function checkIntraday(endDate, isCustom) {
  return isCustom && endDate.isBefore(moment().subtract(2, 'w'));
}

export function getFrequencyDefaults(dateRange, hasCrypto, noIntraday) {
  const { start, end, default: defaultFrequency } = RANGE[dateRange];
  if (hasCrypto && defaultFrequency === 'P7D') {
    return { start, end, defaultFrequency: 'P1M' };
  }
  if (noIntraday && isIntraday(defaultFrequency)) {
    return { start: 'P1D', end: getEnd(end), defaultFrequency: 'P1D' };
  }
  return { start, end, defaultFrequency };
}

function isIntraday(code) {
  return code.includes('T');
}

function getEnd(end) {
  return isIntraday(end) ? 'P1D' : end;
}

function getOptions(start, end) {
  const [startIdx, endIdx] = [start, end].map(findFrequencyIndex);
  return FREQUENCY.slice(startIdx, endIdx + 1);
}

function findFrequencyIndex(prop) {
  return FREQUENCY.findIndex(item => item.value === prop);
}



// WEBPACK FOOTER //
// ./src/ui/constants/marketdata.js